export default "__VITE_ASSET__B$hwcyd7__"